<template>
  <v-footer class="py-3 small-footer" width="50">
    <v-row no-gutters class="mx-2 d-flex flex-wrap flex-direction-column">
      <v-col cols="12" sm="9">
        <span>© 2009 – {{ new Date().getFullYear() }} CodeREADr Inc. All Rights Reserved.</span>
      </v-col>
    <v-spacer class="d-none d-sm-flex"></v-spacer>
    <v-col cols="12" sm="auto" class="text-left text-sm-right">
    <span>version {{ version }}</span>
    </v-col>
    </v-row>
  </v-footer>
</template>

<script setup lang="ts">
import {ref, onBeforeMount} from 'vue';
import Config from "../service/Config";

const version = ref('0.0.0');
const versionChars = ref([]);
onBeforeMount(() => {
  load();
})

function load() {
    if (Config.version < 100) {
        versionChars.value.push(0);
    }
    for (let configV of Config.version) {
        versionChars.value.push(configV);
    }
    version.value = versionChars.value.join('.');
}
</script>

<style scoped lang="scss">
.small-footer {
  max-height: 50px;
  background-color: #343A40;
  color:white;
  position:relative;
  z-index:1007;
  bottom:0;
}
@media (max-width: 768px) {
  .small-footer {
    max-height: 200px;
  }
}
</style>